import { useEffect, useRef } from 'react';

export const AUTO_APPLY_FILTER_DELAY_MS = 300;

/**
 * When enabled, invoke applyFilters with the latest filter state after a short pause.
 * The form stays in control of field values; this only triggers the search.
 */
export function useAutoApplyFilters(
  enabled,
  filters,
  applyFilters,
  delayMs = AUTO_APPLY_FILTER_DELAY_MS
) {
  const applyRef = useRef(applyFilters);
  applyRef.current = applyFilters;

  useEffect(() => {
    if (!enabled) return undefined;
    const timer = setTimeout(() => {
      applyRef.current(filters);
    }, delayMs);
    return () => clearTimeout(timer);
  }, [enabled, filters, delayMs]);
}
